import { PipeTransform, Pipe } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'formatDate',
})
export class FormatDatePipe implements PipeTransform {
  transform(date: string, format?:string): string {
    if(!date){
      return "";
    }
    const newDate = moment(date);

    return newDate.format(format ? format : 'DD/MM/YYYY');
  }
}
